import styled from 'styled-components';
import { Box } from '../../layout/Box';

export const FixedContainer = styled(Box).withConfig({ displayName: 'FixedContainer' }).attrs({
    width: '100%',
    backgroundColor: 'var(--background-primary)',
})`
    transition-property: background-color, backdrop-filter;
    transition-duration: 250ms;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    box-sizing: border-box;
    position: sticky;
    bottom: 0;
    left: 0;
    transform: translate3d(0, 0, 0);
`;
